<template>
    <v-card @click="goToPage" :style="[toPage ? {'cursor': 'pointer', 'border-radius': '8px'} : {'border-radius': '8px'}]">
        <v-card-title>
            <div class="layout column ma-0 justify-space-between pb-1">
                <div class="rectangle-5" :style="{ backgroundColor: color }"></div>
                <div class="title">{{title}}</div>
                <p v-if="description" class="description">{{ description }}</p>
                <div class="text-xs-right">
                </div>
            </div>
        </v-card-title>

        <v-card-text class="pt-1">
            <span class="subheadline">No Período</span>
            <h3 class="headline">R$ {{reachedAmount | fmtFixed}}<span class="caption ml-2">{{caption}}</span></h3>
            <div style="margin-left: 12px; margin-top: 15px;">
                 <div style="width: 100%; display: flex; flex-direction: row;">
                    <!-- <div style="display: flex; flex-direction: column !important; margin-right: 10px;">
                        <span style="color:#555; font-size: smaller; font-weight: 500;">Aguardando Liberação</span>
                        <span style="color:#000; font-size: medium; font-weight: 600;">0,00</span>
                    </div>
                    <div style="display: flex; flex-direction: column !important;  margin-right: 10px;">
                        <span style="color:#555; font-size: smaller; font-weight: 500;">Liberadas</span>
                        <span style="color:#000; font-size: medium; font-weight: 600;">0,00</span>
                    </div>
                    <div style="display: flex; flex-direction: column !important; margin-right: 10px;">
                        <span style="color:#555; font-size: smaller; font-weight: 500;">Canceladas</span>
                        <span style="color:#000; font-size: medium; font-weight: 600;">0,00</span>
                    </div>
                    <div style="display: flex; flex-direction: column !important; margin-left: 10px;">
                        <span style="color:#555; font-size: smaller; font-weight: 500; text-align: right;">De Afiliados Geradas com trending</span>
                        <span style="color:#000; font-size: medium; font-weight: 600; text-align: right;">0,00</span>
                    </div> -->
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
        
        props: {
            icon: String,
            title: String,
            total: Number,
            cancelledAmount: Number,
            reachedAmount: Number,
            lines: Array,
            caption: String,
            color: String,
            description: String,
            linearStatistic: {
                type: Boolean,
                default: true
            },
            todayBalance: {
                type: Number,
                default: 0
            },
            toPage: String
        },

        methods: {
            goToPage() {
                if (this.toPage) {
                    this.$router.push(this.toPage);
                }
            },

            getPercent(value) {
                let p = 0;
                if (value > 0) {
                    p = value / this.total;
                }

                return p;
            },
        },
   };
</script>

<style scoped>
   .corner {
      margin-top: -7px !important;
      margin-right: -7px !important;
      height: 60px;
      width: 95px;
      float: right;
   }

   .description {
      font-size: 15px;
      margin-top: 5px;
      color: #555;
   }

   .rectangle-5 {
        background-color: green;
        border-radius: 0px 30px 30px 0px;
        height: 78px;
        width: 9px;
        margin-left: -16px;
    }

    .title {
        padding-left: 10px;
        margin-top: -70px;
    }

    .headline {
        padding-left: 10px;
    }

    .subheadline {
        padding-left: 10px;
        color: #656565;
        font-weight: 500;
        left: 1px;
        letter-spacing: 0;
    }

    h3 {
        color: black;
        font-weight: 600; 
        font-size: xx-large !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/CommissionsCard.vue